import React, { useEffect, useState } from "react";
import "./Menu.css";
import UserNav from "../../Components/UserNav.jsx/UserNav";
import { Link, useLocation } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCouch
} from "@fortawesome/free-solid-svg-icons";
import moment from "moment";

const Menu = () => {
  const [time, setTime] = useState()
  const location = useLocation();

  useEffect(()=>{
    setInterval(function() {
      let secs = moment().diff(location.state.now, 'seconds');
      let timeWaited = moment.utc(secs*1000).format('mm:ss')
      setTime(timeWaited)
  }, 1 * 1000); // 60 * 1000 milsec
  }, [location.state.now])

 

  return (
    <>
      <UserNav />
      <div className="container login-card">
        <div className="row">
          <div className="col s12 m6">
            <div className="card adminMenu" id="fin-container">
              <div className="card-content white-text">
              
                <h3 className="center-align finHead blk">You're All Set!</h3>
                <FontAwesomeIcon className="fin-con" icon={faCouch} size="lg" />
                <p className="center-align finDesc">
                  {`Thank you ${location.state.userName}, please have a seat in our waiting area until your name is up
                  on the screen. If you happen to step out and your name comes up, we will call you at ${location.state.userPhone}.`}
                </p>
                <p className="center-align finDesc blk ">
                  {" "}
                  {`Your ${location.state.title} was queued at ${location.state.displayNow}, ${time} minutes ago`}
                </p>
                <Link to="/" > <button className="btn queue-btn">Start Over</button></Link>
            
              </div>
            </div>
          </div>
        </div>
        
      </div>
    </>
  );
};

export default Menu;
